import React from "react";
import { FeatureCard } from "./FeatureCard";

interface FeatureGridProps {
	features: Array<{
		icon: React.ReactNode;
		title: string;
		description: string;
	}>;
}

export function FeatureGrid({ features }: FeatureGridProps) {
	return (
		<div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
			{features.map((feat, i) => (
				<div
					key={i}
					className="scroll-reveal"
					style={{ transitionDelay: `${i * 100}ms` }}
				>
					<FeatureCard
						icon={feat.icon}
						title={feat.title}
						description={feat.description}
					/>
				</div>
			))}
		</div>
	);
}
